module.exports = {"pathContext":{"name":"CensusKennelConnection","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"edges","type":{"kind":"LIST","name":null,"ofType":{"kind":"OBJECT","name":"CensusKennelEdge","ofType":null}}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"pageInfo","type":{"kind":"NON_NULL","name":null,"ofType":{"kind":"OBJECT","name":"PageInfo","ofType":null}}}],"description":null,"enumValues":null,"possibleTypes":null}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/object-census-kennel-connection.json
// module id = 1688
// module chunks = 162652885161264